import { IAdobeInteraction } from "@abbvie-epi/common/adobe-analytics";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";

@Component({
    selector: "app-bottom-navigation",
    templateUrl: "./bottom-navigation.component.html",
    styleUrls: ["./bottom-navigation.component.scss"]
})
export class BottomNavigationComponent implements OnInit {
    @Input() backRoute: string;
    @Input() backTab: string;
    @Input() backText: string = "";
    @Input() showBackNav: boolean = false;

    @Input() continueRoute: string;
    @Input() continueTab: string;
    @Input() continueText: string = "";

    @Input() analyticsTitles: {
        back: string;
        continue: string;
    } | null = null;

    constructor(private router: Router, private analyticsHelpers: AnalyticsHelperService) {}

    public whiteBackwards: string = "";
    public whiteForwards: string = "";

    ngOnInit(): void {}

    public navigateBack() {
        if (this.backRoute && this.backTab) {
            const overrides = this.getAnalyticsBackOverrides(this.backText || "", this.backRoute, this.backTab);

            this.analyticsHelpers.trackInteraction("global-bottom-nav-back", overrides);
            this.router.navigate([this.backRoute], { fragment: this.backTab });
        } else if (this.backRoute) {
            const overrides = this.getAnalyticsBackOverrides(this.backText || "", this.backRoute);

            this.analyticsHelpers.trackInteraction("global-bottom-nav-back", overrides);
            this.router.navigate([this.backRoute]);
        } else {
            throw Error("No route available");
        }
    }

    public navigateForward() {
        if (this.continueRoute && this.continueTab) {
            const overrides = this.getAnalyticsContinueOverrides(
                this.continueText,
                this.continueRoute,
                this.continueTab
            );
            this.analyticsHelpers.trackInteraction("global-bottom-nav-continue", overrides);
            this.router.navigate([this.continueRoute], { fragment: this.continueTab });
        } else if (this.continueRoute) {
            const overrides = this.getAnalyticsContinueOverrides(this.continueText, this.continueRoute);
            this.analyticsHelpers.trackInteraction("global-bottom-nav-continue", overrides);
            this.router.navigate([this.continueRoute]);
        } else {
            throw Error("No route available");
        }
    }

    public mobileNavigation() {
        if (this.showBackNav) {
            const overrides = this.getAnalyticsBackOverrides(this.backText || "", this.backRoute);
            this.analyticsHelpers.trackInteraction("global-bottom-nav-back", overrides);
            this.router.navigate([this.backRoute]);
        } else {
            const overrides = this.getAnalyticsContinueOverrides(this.continueText, this.continueRoute);
            this.analyticsHelpers.trackInteraction("global-bottom-nav-continue", overrides);
            this.router.navigate([this.continueRoute], { fragment: this.continueTab });
        }
    }

    private getAnalyticsBackOverrides(linkTitle: string, route: string, fragment?: string): IAdobeInteraction {
        return {
            link: {
                name: `BACK TO: ${linkTitle}`,
                title: `BACK TO...${linkTitle}`,
                url: `${route}${fragment || ""}`
            }
        };
    }

    private getAnalyticsContinueOverrides(linkTitle: string, route: string, fragment?: string): IAdobeInteraction {
        return {
            link: {
                name: `CONTINUE TO: ${linkTitle}`,
                title: `CONTINUE TO...${linkTitle}`,
                url: `${route}${fragment ? "#" + fragment : ""}`
            }
        };
    }
}
